const ranges = [
    '[\u00A0-\u269f]',
    '[\u26A0-\u329f]',
    '[🀄-🫶]'
  ];

export const removeEmoji = (text: string) => {
  return text.replace(new RegExp(ranges.join('|'), 'ug'), '');
};